import clsx from 'clsx';

const TONES = {
  neutral: 'bg-surface-subtle text-ink-muted ring-1 ring-inset ring-border',
  brand: 'bg-accent-soft text-accent ring-1 ring-inset ring-accent/20',
  success: 'bg-success/8 text-success ring-1 ring-inset ring-success/15',
  warning: 'bg-warning/8 text-warning ring-1 ring-inset ring-warning/15',
  danger: 'bg-danger/8 text-danger ring-1 ring-inset ring-danger/15',
  info: 'bg-info/8 text-info ring-1 ring-inset ring-info/15'
};

export function Badge({ tone = 'neutral', className, children }) {
  return (
    <span className={clsx('inline-flex items-center rounded-md px-1.5 py-0.5 text-[11px] font-medium', TONES[tone], className)}>
      {children}
    </span>
  );
}
